jQuery_T4NT(document).ready(function ($) {

  localStorage.setItem('T4Currency', $('.t4s-top-bar__currencies').find('span.flagst4').text())
          function getGeo(){
          var myHeaders = new Headers();
          myHeaders.append('pragma', 'no-cache');
          myHeaders.append('cache-control', 'no-cache');
          
          var myInit = {
            method: 'GET',
            headers: myHeaders,
          };
          localStorage.removeItem('user_region');
        fetch('http://ipwho.is/', myInit)
        .then(response => response.json())
        .then(data => {
          localStorage.setItem('user_region', data.region_code);
        })
        .catch(error => {
          console.error('Error fetching country information:', error);
        });
            }
  /**
  *  Variant selection changed
  *  data-variant-toggle="{{variant.id}}"
  */
  // 	   $( document ).on( "variant:changed", function( evt ) {
  // 	     // console.log( evt.currentVariant );
  // 	     // $('[data-variant-toggle]').hide(0);
  // 	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
  // 	   });
  // // box_input_js
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}


  function totalPrice() {
    var sqft_per_box = $('.sqft_input_js').attr('min');
    var box = parseFloat($('.box_input_js').val());
    var qty = Math.ceil(sqft_per_box * box); 
    if(qty < sqft_per_box){ qty = sqft_per_box; }
    $('.qty_input_js').val(qty);
    var price = parseFloat($('.qty_input_js').data('price'));
    var total = qty * price;
    $('.estimated-cost').html(T4SThemeSP.Currency?.formatMoney(total));
  }

  function calculate_Waste_Factor() {
    var perc = parseFloat($('.waste_input_js').val()) / 100;
    var sqft_per_box = $('.sqft_input_js').attr('min');
    var sqft = parseFloat($('.sqft_input_js').val());
    var waste_factor = sqft * perc;
    if ($('.waste_input_js').is(':checked')) {
      sqft = sqft + waste_factor;
      $('#waste-factor-total span').html(waste_factor.toFixed(2));
    }

    var box = Math.ceil(sqft / sqft_per_box);
    if (box <= 0  || isNaN(box)) { box = 1 };

    // Never allow more boxes than are in stock (data-max-boxes comes from form-calculator.liquid)
    var maxBoxes = parseInt($('.box_input_js').attr('data-max-boxes'), 10);
    if (maxBoxes > 0 && box > maxBoxes) {
      box = maxBoxes;
      $('.sqft_input_js').val((maxBoxes * sqft_per_box).toFixed(2));
      $('#waste-factor-total span').html('0.00');
      $('.stock-limit-error').removeClass('hide');
    } else {
      $('.stock-limit-error').addClass('hide');
    }

    // Minimum boxes per order (data-min-boxes comes from form-calculator.liquid, e.g. Mohawk = 3)
    var minBoxes = parseInt($('.box_input_js').attr('data-min-boxes'), 10);
    if (minBoxes > 1 && box < minBoxes) {
      box = minBoxes;
      $('.sqft_input_js').val((minBoxes * sqft_per_box).toFixed(2));
      $('#waste-factor-total span').html('0.00');
      $('.min-boxes-error').removeClass('hide');
    } else {
      $('.min-boxes-error').addClass('hide');
    }

    $('.box_input_js').val(box);
    totalPrice();
  }

  $('body').on('input change', '.sqft_input_js', function (evt) {
    var sqft_per_box = $('.sqft_input_js').attr('min');
    var sqft = parseFloat($(this).val());
    box = Math.ceil(sqft / sqft_per_box);
    if (box <= 0 || isNaN(box)) { box = 1 };
    $('.box_input_js').val(box);

    if (sqft < sqft_per_box  || isNaN(sqft)) {
      $('.min-qty-error').removeClass('hide');
    } else { $('.min-qty-error').addClass('hide'); }

    calculate_Waste_Factor();
  });

  $('body').on('input change', '.box_input_js', function (evt) {
    var box = parseInt($(this).val());
    var sqft_per_box = $('.sqft_input_js').attr('min');
    var sqft = sqft_per_box * box;
    $('.sqft_input_js').val(sqft);
    $('.min-qty-error').addClass('hide');
    calculate_Waste_Factor();
  });

  $('body').on('change', '.waste_input_js', function (evt) {
    if ($(this).is(':checked')) {
      $('#waste-factor-total').removeClass('hide');
    } else {
      $('#waste-factor-total').addClass('hide');
    }
    calculate_Waste_Factor();
  });

  $('body').on('click', '.cal_coverage_js', function(evt){
    $('#coverage-calculate').removeClass('hidden');

  });

  $('body').on('click', '.coverage-calculate-close', function(evt){
    $('#coverage-calculate').addClass('hidden');
  });


 $('body').on('click', '.add_row_js', function(evt){
   var html = `<div class="flex items-center justify-between mb-2 text-black uppercase text-xxs coverage-area-group">
              <div class="w-1/4 coverage-length">
              <input type="number" min="1" step=".01" placeholder="LENGTH" class="coverage_length w-full px-3 py-2 coverage-length-input bg-black/10"></div>
              <div class="text-xs coverage-symbol">✕</div>
              <div class="w-1/4 coverage-width">
              <input type="number" min="1" step=".01" placeholder="WIDTH" class="coverage_width w-full px-3 py-2 coverage-width-input bg-black/10"></div>
              <div class="text-xs coverage-symbol">=</div>
              <div class="w-1/3 coverage-area">
                <input type="number" disabled="disabled" class="coverage_area w-full px-3 py-2 coverage-area-output bg-black/20">
              </div>
            </div>`;


   $('.coverage-area-wrap').append(html);

   
 });

  function total_coverageArea(){
    var total = 0;
    $('.coverage-area-wrap .coverage_area').each(function(){
      var value = parseFloat($(this).val());
      if(value > 0){
        total = total + value;
      }
    });
   if(total > 0){
    $('.coverage-area-final').val(total);
   }
  }

  $('body').on('input change', '.coverage-area-wrap .coverage_width, .coverage-area-wrap .coverage_length', function(evt){
       var parent = $(this).parents('.coverage-area-group');
       var length = parseFloat(parent.find('input.coverage_length').val());
       var width = parseFloat(parent.find('input.coverage_width').val());
       var area  = length * width;
           area  = area.toFixed(2);
      
        parent.find('input.coverage_area').val(area);
        total_coverageArea();
  });



  $('body').on('click', '.use-coverage_js', function(evt){
        var coverage_area = parseFloat($('.coverage-area-final').val()).toFixed(2);
      if(coverage_area > 0){
             
         $('.sqft_input_js').val(coverage_area);
         $('.sqft_input_js').trigger('input');
        $('#coverage-calculate').addClass('hidden');
      }

   });
  //document.querySelectorAll('.js-product-samples').forEach(item => item.classList.remove[0]);
   async function loading(){
     
    // await console.log('Echeck Element =>>>>>',$(document)[0].readyState)
    while ($(document)[0].readyState !== 'complete') {
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
  // console.log('Echeck Element =>>>>>',$('div.product-samples-button-wrap'))
    return true;
}

    try { totalPrice(); } catch(e) {}

  

 });

/* ------------------------------------------------------------------
 * Consultation popup — BC-only, exactly two showings per session
 * Added 2026-08-19, revised 2026-08-21.
 *
 * WHY THIS EXISTS
 * The in-home consultation service only covers British Columbia, so the
 * popup should not be shown to visitors elsewhere. Shopify Liquid cannot
 * do this: localization.country only knows Canada vs USA, never the
 * province. So the region is resolved client-side from the visitor's IP.
 *
 * HOW IT WORKS
 *  1. As early as possible we wrap $.magnificPopupT4s.open and block ONLY
 *     this popup (other popups — quickview, compare, cart — are untouched).
 *     Blocking starts immediately so the theme's 10s timer cannot beat the
 *     region lookup.
 *  2. The region is looked up once and cached in localStorage for 7 days,
 *     so a visitor causes one request, not one per page.
 *  3. In BC  -> unblock. If the theme already tried during the lookup, we
 *     replay that attempt so the visitor still sees it on time.
 *     Outside BC -> stays blocked, silently.
 *     Lookup failed/timed out -> FAIL OPEN (show it). A false positive is
 *     far cheaper than hiding the offer from a real BC customer.
 *  4. Second showing fires 3 minutes after the first, opened directly.
 *     Tracked in sessionStorage so the timer survives page navigation.
 *
 * NOTE: the block's day_next setting must stay >= 1. The theme's cookie
 * library does `new Date(Date.now() + 864e5 * expires)`, so day_next: 0
 * expires the "already shown" cookie instantly and the popup then reopens
 * on every single page load.
 * ------------------------------------------------------------------ */
(function () {
  var FIRST_AT    = 'yfPopupFirstShownAt';
  var SECOND_DONE = 'yfPopupSecondShown';
  var GEO_VALUE   = 'yfGeoRegion';
  var GEO_STAMP   = 'yfGeoRegionAt';
  var GEO_TTL_MS  = 7 * 864e5;          // cache region for 7 days
  var REPEAT_AFTER_MS = 3 * 60 * 1000;  // 3 minutes
  var LOOKUP_TIMEOUT_MS = 4000;
  var SELECTOR = '#t4s-popup__newsletter';
  var SERVICE_AREA = 'CA-BC';           // country_code + '-' + region_code

  var allowed = null;        // null = still resolving, then true / false
  var blockedAttempt = false;
  var patched = false;

  function store(api, key, val) {
    try {
      if (arguments.length > 2) { api.setItem(key, val); return val; }
      return api.getItem(key);
    } catch (e) { return null; }
  }
  function ls(k, v) { return arguments.length > 1 ? store(localStorage, k, v) : store(localStorage, k); }
  function ss(k, v) { return arguments.length > 1 ? store(sessionStorage, k, v) : store(sessionStorage, k); }
  function jq() { return window.jQuery_T4NT || window.jQuery; }

  /* --- 1. block this popup until we know where the visitor is --------- */
  function patchOpener() {
    if (patched) return true;
    var $ = jq();
    if (!$ || !$.magnificPopupT4s || typeof $.magnificPopupT4s.open !== 'function') return false;
    var original = $.magnificPopupT4s.open;
    $.magnificPopupT4s.open = function (opts) {
      var src = opts && opts.items && opts.items.src;
      if (src === SELECTOR && allowed !== true) {
        if (allowed === null) blockedAttempt = true;   // replay once allowed
        return;
      }
      return original.apply(this, arguments);
    };
    patched = true;
    return true;
  }

  function keepTryingToPatch() {
    if (patchOpener()) return;
    var tries = 0;
    var iv = setInterval(function () {
      if (patchOpener() || ++tries > 120) clearInterval(iv);   // give up after ~30s
    }, 250);
  }

  /* --- 2. resolve region (cached), fail open on any problem ----------- */
  function resolveRegion(done) {
    var cached = ls(GEO_VALUE);
    var at = parseInt(ls(GEO_STAMP), 10);
    if (cached && at && (Date.now() - at) < GEO_TTL_MS) { done(cached); return; }

    var settled = false;
    function finish(v) { if (!settled) { settled = true; done(v); } }
    setTimeout(function () { finish(null); }, LOOKUP_TIMEOUT_MS);

    try {
      fetch('https://ipwho.is/?fields=success,country_code,region_code')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var v = (d && d.success && d.country_code && d.region_code)
            ? (d.country_code + '-' + d.region_code) : null;
          if (v) { ls(GEO_VALUE, v); ls(GEO_STAMP, String(Date.now())); }
          finish(v);
        })
        .catch(function () { finish(null); });
    } catch (e) { finish(null); }
  }

  /* --- 3. showings --------------------------------------------------- */
  function popupIsVisible() {
    var el = document.querySelector(SELECTOR);
    return !!(el && el.offsetParent !== null);
  }
  function themeCookieSet() {
    return /(?:^|;\s*)[^;=]*_newsletter\s*=/.test(document.cookie);
  }
  function shownAlready() { return popupIsVisible() || themeCookieSet(); }

  function openPopup() {
    var $ = jq();
    if (!$ || !$.magnificPopupT4s || !document.querySelector(SELECTOR)) return false;
    if (document.querySelector('.mfp-ready')) return false;   // something already open
    try {
      $.magnificPopupT4s.open({ items: { src: SELECTOR }, type: 'inline', removalDelay: 500 });
      return true;
    } catch (e) { return false; }
  }

  function scheduleSecondShowing() {
    if (ss(SECOND_DONE)) return;
    var first = parseInt(ss(FIRST_AT), 10);
    if (!first) return;
    var wait = REPEAT_AFTER_MS - (Date.now() - first);
    if (wait < 0) wait = 0;
    setTimeout(function () {
      if (ss(SECOND_DONE) || allowed !== true) return;
      ss(SECOND_DONE, '1');       // mark used even if opening fails — never retry
      openPopup();
    }, wait);
  }

  function watchForFirstShowing() {
    if (ss(SECOND_DONE)) return;
    if (ss(FIRST_AT)) { scheduleSecondShowing(); return; }
    var poll = setInterval(function () {
      if (shownAlready()) {
        clearInterval(poll);
        ss(FIRST_AT, String(Date.now()));
        scheduleSecondShowing();
      }
    }, 500);
    setTimeout(function () { clearInterval(poll); }, 120000);
  }

  /* --- 4. go --------------------------------------------------------- */
  function start() {
    keepTryingToPatch();
    resolveRegion(function (region) {
      allowed = (region === null) ? true : (region === SERVICE_AREA);
      if (!allowed) return;                       // outside BC: stay silent
      if (blockedAttempt) { blockedAttempt = false; openPopup(); }
      watchForFirstShowing();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
